<template>
  <div>
    <!-- <div
      v-if="!!$config.sms_module_test && last_date"
      class="filter filter--block filter-hint mb-4"
    >
      {{ $t('shared.component.table.last_date') }}{{ last_date }}
    </div> -->
    <filter-wrapper @submit="submit">
      <div class="filter__row">
        <div class="filter__item col-3">
          <label class="filter__item__title">
            {{ $t('mailer.stats.detailed.filter.number.title') }}
          </label>
          <div class="filter__item__body">
            <i-input v-model="form.number" type="number" :clearable="true" />
          </div>
        </div>

        <div class="filter__item col-3">
          <label class="filter__item__title">
            {{ $t('mailer.stats.detailed.filter.status.title') }}
          </label>
          <div class="filter__item__body">
            <mailings-input-status v-model="form.status" />
          </div>
        </div>

        <div class="filter__item col-3">
          <label class="filter__item__title">
            {{ $t('mailer.stats.general.filter.sender.title') }}
          </label>
          <div class="filter__item__body">
            <mailings-stats-filter-input-sender v-model="form.sender" />
          </div>
        </div>

        <div class="filter__item col-3">
          <label class="filter__item__title">
            {{ $t('mailer.stats.detailed.filter.mailing.title') }}
          </label>
          <div class="filter__item__body">
            <mailings-input-select-mailing v-model="form.mailing_id" />
          </div>
        </div>
      </div>

      <div class="filter__row filter__row--space-between">
        <div class="filter__item filter__item--datepicker">
          <label class="filter__item__title">
            {{ $t('shared.component.filter.period') }}
          </label>
          <div class="filter__item__body">
            <date-range-picker v-model="form.date" />
          </div>
        </div>

        <div class="filter__button-group">
          <div class="filter__item filter__item--button">
            <i-button html-type="submit" type="primary">
              {{ $t('shared.component.filter.show_result') }}
            </i-button>
          </div>
          <tooltip
            :content="
              !form.date.start || !form.date.end
                ? $t('shared.validation_errors.enter_date')
                : $t('mailer.export.not_export')
            "
            theme="light"
            :transfer="true"
            placement="top"
            min-width="200"
            max-width="200"
            style="align-self: flex-end"
            :disabled="is_export_allowed && !disabled_export_btn"
          >
            <dropdown v-if="is_export_allowed" trigger="click" class="export-dropdown filter__item">
              <i-button type="primary" class="export-report" :disabled="disabled_export_btn">
                {{ $t('shared.component.export_report.export_btn') }}
                <i class="ivu-icon ivu-icon-ios-arrow-down"></i>
              </i-button>
              <dropdown-menu slot="list">
                <dropdown-item class="export-option">
                  <div class="export-btn" @click="exportRequest('xls')">
                    {{ $t('shared.component.export_report.xls') }}
                  </div>
                </dropdown-item>
                <dropdown-item class="export-option">
                  <div class="export-btn" @click="exportRequest('csv')">
                    {{ $t('shared.component.export_report.csv') }}
                  </div>
                </dropdown-item>
              </dropdown-menu>
            </dropdown>
          </tooltip>
        </div>
      </div>
    </filter-wrapper>
  </div>
</template>

<script>
  import FilterWrapper from '@shared/components/filter-base';
  import { mapActions, mapGetters } from 'vuex';
  import { initSearchStateByPeriod, parseSearchStateByPeriod } from '@shared/helpers/date_format';
  import { SmsService } from '@mailer/services/SmsService';
  import MailingsInputStatus from '@mailer/components/mailings/mailings-input-status';
  import MailingsInputSelectMailing from '@mailer/components/mailings/mailings-input-select-mailing';
  import MailingsStatsFilterInputSender from '@mailer/components/stats/mailings-stats-filter-input-sender';
  import Vue from 'vue';
  import excel from 'vue-excel-export';

  Vue.use(excel);

  export default {
    components: {
      MailingsInputSelectMailing,
      MailingsInputStatus,
      MailingsStatsFilterInputSender,
      FilterWrapper
    },
    data: () => ({
      last_date: '',
      mailings: [],
      form: {
        number: '',
        status: '',
        sender: '',
        mailing_id: null,
        date: initSearchStateByPeriod(30)
      }
    }),
    computed: {
      ...mapGetters('mailer/archived_stats/detailed', { data: 'data' }),
      is_export_allowed() {
        return this.$permission.service_mailing_detail_stats_export_is_allowed;
      },
      disabled_export_btn() {
        return this.data?.length == 0 || !this.form.date.start || !this.form.date.end;
      }
    },
    created() {
      const { start, end } = parseSearchStateByPeriod(this.form.date);
      const { number, status, sender, mailing_id } = this.form;

      const params = {
        number,
        sender,
        mailing_id: mailing_id,
        state: status,
        start: start,
        end: end
      };

      this.search(params);
    },
    methods: {
      ...mapActions('mailer/archived_stats/detailed', ['search', 'getData', 'set_datePicker']),

      getFormData(is_export) {
        const { start, end } = parseSearchStateByPeriod(this.form.date);
        const { number, status, sender, mailing_id } = this.form;

        /* merge можно не передавать, по умолчанию будет мерджить со старой статой
        передаем, чтобы метод лишний раз не ходил в старую стату. */
        return {
          number,
          sender,
          mailing_id: mailing_id,
          state: is_export ? undefined : status,
          status: is_export ? status : undefined,
          merge: is_export ? !this.$user.sms_stats_from_new_module_allowed : undefined,
          start: start,
          end: end
        };
      },

      exportRequest(format) {
        const params = this.getFormData(true);

        SmsService.downloadReport(format, params)
          .then(() => {
            this.$noty.success(this.$t('shared.component.noty.export_started'));
          })
          .catch((error) => this.$noty.new_server_error(error));
      },

      submit: function () {
        const params = this.getFormData();

        this.search(params);
      }
    }
  };
</script>

<style lang="scss">
  .export-dropdown {
    width: 160px;
    align-self: flex-end;
  }

  .export-report {
    background: $blue-grey-dark;
    border-color: $blue-grey-dark;
    outline: none;
    text-transform: uppercase;

    &:hover {
      background: $blue-grey;
      border-color: $blue-grey;
    }

    &:disabled {
      background: $blue-grey-light;
      border-color: $blue-grey-light;

      &:hover {
        background: $blue-grey-light;
        border-color: $blue-grey-light;
      }
    }
  }

  .export-option {
    text-transform: uppercase;
    padding: 0;
  }

  .export-btn {
    padding: 7px 16px;
  }
</style>
